import React from 'react'
import { useLocation } from 'react-router-dom'

interface PublicRouteProps{
    children: any
}

/** Paths that must not wipe auth storage (standalone public pages). */
const PRESERVE_STORAGE_PATHS = ['/auction', '/paymentinfo', '/unsubscribe']

const PublicRoute: React.FC<PublicRouteProps> = ({children}) => {
  const { pathname } = useLocation()
  const shouldPreserveStorage = PRESERVE_STORAGE_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  )
  // Login / password flows still clear storage; auction must not log admins out.
  if (!shouldPreserveStorage) {
    localStorage.clear()
  }
  return children
}

export default PublicRoute
